module.exports = __webpack_public_path__ + "static/media/platoducha.c1acdbac.svg";